import React from "react";
import Campaign from "../Campaign.js";
import { connect } from "react-redux";
import style from "./SaasExtraOptions.module.css";
import { customSaasOptionValidationMessages } from "../../redux/selectors";
import Alerts from "../shared/Alerts";
import { Form, FormControl, InputGroup, Table } from "react-bootstrap";
import { OnBlurInput } from "../OnBlurInput";
import { clamp } from "lodash-es";

const SaasExtraOptions = ({
  customOptionValidationMessages,
  subscriptionTerm,
  subscriptionTermFrequency,
  financeTypes,
  financeType,
  onSubscriptionTermChanged,
  onFinanceTypeChanged,
  isExisting,
  ExistingTenantLabel,
  ExistingTenantValue,
  onExistingTenantUpdated
}) => {
  return (
    <Form className={style.root}>
      <h2 className={style.head}>SaaS Options</h2>
      <Alerts alerts={customOptionValidationMessages} />
      <Table variant="sm" className={style.table}>
        <tbody>
          {isExisting && (
           <tr>
              <td><span>{ExistingTenantLabel}</span></td>
              <td>
                <FormControl as={OnBlurInput} type="text"
                  value={ExistingTenantValue}
                  onConfirm={e => onExistingTenantUpdated(e.target.value)}
                  required
                />
              </td>
            </tr>
          )}
          <tr>
            <td>
              <div>
                <span>Saas Term</span><br />
                <span>{subscriptionTermFrequency === "annual" ? "1 to 5 Years" : "12 to 65 Months"}</span>
              </div>
            </td>
            <td>
              {subscriptionTermFrequency === "annual"
                ? <InputGroup>
                    <FormControl as={OnBlurInput} type="number"
                      value={subscriptionTerm / 12}
                      onConfirm={e => onSubscriptionTermChanged(clamp(Math.floor(e.target.value) * 12, 12, 60))} //todo we need to fix this, as current math means max 60, but they need up to 65 with deferred payments
                      required
                    />
                    <InputGroup.Append>
                      <InputGroup.Text>Years</InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
                : <InputGroup>
                    <FormControl as={OnBlurInput} type="number"
                      value={subscriptionTerm}
                      onConfirm={e => onSubscriptionTermChanged(clamp(e.target.value, 12, 65))}
                      required
                    />
                    <InputGroup.Append>
                      <InputGroup.Text>Months</InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
              }
              
            </td>
          </tr>
          <tr>
            <td>Saas Finance Type</td>
            <td>
              <select 
              value={financeType} 
              onChange={e => onFinanceTypeChanged(e.target.value)} 
              style={{flexGrow: 1, border: '1px solid lightgray', borderRadius: '0 4px 4px 0'}} >
                {
                  financeTypes.map(item => {
                      return <option key={item} value={item}>{item}</option>
                  })
                }
              </select>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              Cash - Sold as subscription software<br />
              Finance - Financed into the total hardware rental  
            </td>
          </tr>
          <tr>
            <td colSpan={2}><i>If you change the Quote Finance Type or SubType, please refresh the page</i></td>
          </tr>
        </tbody>
      </Table>
      <Campaign />
    </Form>
  );
}

export default connect(
  state => ({
    customOptionValidationMessages: customSaasOptionValidationMessages(state),
    }), 
    {
    })
  (SaasExtraOptions);